<template>
  <b-container v-if="this.$root.signedIn">
    <br>
    <h3>SMART Goal Setting Sessions</h3>
    <br>
    <b-tabs v-model="tabIndex">
      <b-tab title="Search SMART Goals">
        <smart-goal-search @edit-session="sessionToEdit = $event; tabIndex = 1;"/>
      </b-tab>
      <b-tab title="Enter SMART Goals">
        <smart-goal-add-edit :session-to-edit="sessionToEdit"/>
      </b-tab>
    </b-tabs>
  </b-container>

</template>
<script>
// @ is an alias to /src
import SmartGoalAddEdit from "@/components/SmartGoalAddEdit.vue";
import SmartGoalSearch from "@/components/SmartGoalSearch.vue";

export default {
  name: "GoalSetting",
  components: {
    SmartGoalAddEdit,
    SmartGoalSearch
  },
  data() {
    return {
      sessionToEdit: {},
      tabIndex: 0
    };
  }
}
</script>



// WEBPACK FOOTER //
// src/views/GoalSetting.vue